
import { usePageTitle } from 'utils/pageTitle';

import { faqConfig } from 'pages/faq/faqConfig'
import FaqCollapse from 'pages/faq/FaqCollapse'

import './FaqPage.css';


export default function FaqPage() {
	usePageTitle('FAQ');
 return (
		<div className="faq-page">
			<div className="faq-container">
				<div className="faq-contents">
					<div className="faq-page-header">
						<span>Frequently Asked Questions</span>
						<img className="violerts-logo" src="/violerts-monogram.png" alt="Violerts logo" />
					</div>

			 		{Object.entries(faqConfig).map(([groupLabel, items]) => {
			 			return (
			 				<div key={groupLabel} className="faq-section">
			 					<div className="section-header">
			 						<span>{groupLabel}</span>
			 					</div>
			 					<div>
			 						{items.map((item, i) => (
			 							<FaqCollapse key={i} item={item} />
			 						))}
			 					</div>
			 				</div>
			 			);
			 		})}
				 </div>
			 </div>
		 </div>
	);
}